import pulseSurveyReducer from "./PulseSurvey.reducer";

export default pulseSurveyReducer;
